// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77f5131e","239":"ba423de0","488":"93cee8da","732":"0bd2c81a","839":"645fa93a"}[chunkId] + ".chunk.js";
};